<!-- Filtros -->
<div class="po-row po-mb-3 po-pt-4">
  <div class="po-row">
    <po-combo
      class="po-sm-12 po-md-3 po-lg-2 custom-filters"
      name="filterGoal"
      p-label="Premissa"
      [(ngModel)]="filterGoal"
      [p-filter-service]="goalFilterService"
      p-remove-initial-filter
    ></po-combo>

    <po-combo
      class="po-sm-12 po-md-3 po-lg-2 custom-filters"
      name="filterPo"
      p-label="PO"
      [(ngModel)]="filterPo"
      [p-filter-service]="poFilterService"
      p-remove-initial-filter
    ></po-combo>

    <po-combo
      class="po-sm-12 po-md-3 po-lg-2 custom-filters"
      name="filterProjectKey"
      p-label="Projeto"
      [(ngModel)]="filterProjectKey"
      [p-filter-service]="projectFilterService"
      p-remove-initial-filter
    ></po-combo>

    <po-combo
      class="po-sm-12 po-md-3 po-lg-2 custom-filters"
      name="filterReleaseId"
      p-label="Release"
      [(ngModel)]="filterReleaseId"
      [p-filter-service]="releaseFilterService"
      p-remove-initial-filter
    ></po-combo>

    <po-input
      class="po-sm-12 po-md-3 po-lg-2 custom-filters"
      name="filterRuleKey"
      p-label="Regra (chave)"
      p-placeholder="Ex: java:S1234"
      p-clean
      [(ngModel)]="filterRuleKey"
      (keyup.enter)="onFilterChange()"
    ></po-input>
  </div>

  <div class="po-row">
    <po-combo
      class="po-sm-12 po-md-3 po-lg-2 custom-filters"
      name="filterSquad"
      p-label="Squad"
      [(ngModel)]="filterSquad"
      [p-filter-service]="squadFilterService"
      p-remove-initial-filter
    ></po-combo>

    <po-combo
      class="po-sm-12 po-md-3 po-lg-2 custom-filters"
      name="filterModule"
      p-label="Módulo"
      [(ngModel)]="filterModule"
      [p-filter-service]="moduleFilterService"
      p-remove-initial-filter
    ></po-combo>

    <po-combo
      class="po-sm-12 po-md-3 po-lg-2 custom-filters"
      name="filterTribe"
      p-label="Tribe"
      [(ngModel)]="filterTribe"
      [p-filter-service]="tribeFilterService"
      p-remove-initial-filter
    ></po-combo>
  </div>

  <div class="po-row">
    <div class="po-sm-12 po-md-12 po-lg-4 filter-actions">
      <po-button
        p-label="Aplicar Filtros"
        p-kind="primary"
        p-icon="po-icon-filter"
        [p-disabled]="loading"
        (p-click)="onFilterChange()"
      ></po-button>

      <po-button
        p-label="Limpar"
        p-kind="secondary"
        p-icon="po-icon-clear-content"
        (p-click)="clearFilters()"
      ></po-button>
    </div>
  </div>
</div>

<div class="filter-export-row">
  <po-button
    p-label="CSV"
    p-kind="secondary"
    p-icon="po-icon-export"
    [p-loading]="exportingCsv"
    [p-disabled]="issues.length === 0"
    (p-click)="exportCsv()"
  ></po-button>
</div>

<!-- Tabela -->
<po-table
  [p-columns]="tableColumns"
  [p-items]="issues"
  [p-loading]="loading"
  [p-sort]="true"
  [p-actions]="tableActions"
  [p-show-more-disabled]="(currentPage * itemsPerPage) >= totalItems"
  [p-literals]="{ noData: 'Nenhuma issue encontrada para os filtros selecionados', showMore: 'Carregar mais' }"
  (p-show-more)="onShowMore()"
>
  <ng-template p-table-column-template [p-property]="'goal'" let-value>
    {{ getGoalLabel(value) }}
  </ng-template>
</po-table>

<!-- Modal: Detalhes da Issue -->
<po-modal
  #modalDetail
  p-title="Detalhes da Issue"
  p-size="lg"
  [p-primary-action]="modalDetailCloseAction"
>
  <ng-container *ngIf="selectedIssue">
    <po-table
      class="no-header-table"
      [p-items]="detailItems"
      [p-hide-columns-manager]="true"
      [p-striped]="true"
    ></po-table>

    <ng-container *ngIf="selectedIssue.sonar_url">
      <po-divider p-label="Link SonarQube"></po-divider>
      <div class="issue-message-block">
        <span class="po-icon po-icon-link issue-message-icon"></span>
        <a [href]="selectedIssue.sonar_url" target="_blank" rel="noopener noreferrer" class="issue-sonar-link">Abrir no SonarQube</a>
      </div>
    </ng-container>

    <ng-container *ngIf="selectedIssue.message">
      <po-divider p-label="Mensagem"></po-divider>
      <div class="issue-message-block">
        <span class="po-icon po-icon-info issue-message-icon"></span>
        <p class="issue-message-text">{{ selectedIssue.message }}</p>
      </div>
    </ng-container>
  </ng-container>
</po-modal>
